export const SET_PLANS = "SET_PLANS";


